import { gql } from '@/__generated__';
import { CollectionsAccess_GetCollectionsForDeviceAccessQuery } from '@/__generated__/graphql';

export type CollectionForDeviceAccess =
  CollectionsAccess_GetCollectionsForDeviceAccessQuery['allCollections'][number];

export type AssignedCollectionForDeviceAccess =
  CollectionsAccess_GetCollectionsForDeviceAccessQuery['assignedCollections'][number];

const GET_COLLECTIONS_FOR_DEVICE_ACCESS = gql(`#graphql
  query CollectionsAccess_GetCollectionsForDeviceAccess($organizationIds: [Int!], $deviceId: String!) {
    allCollections: collections(filter: { organizationIds: $organizationIds }) {
      id
      name
      type
      organizationId
      organization {
        id
        name
      }
    }
    assignedCollections: collections(filter: { deviceId: $deviceId }) {
      id
      name
      type
      organizationId
      organization {
        id
        name
      }
      deviceCollectionRelationId(deviceId: $deviceId)
      callerCanManageAccess
    }
  }
`);

export default GET_COLLECTIONS_FOR_DEVICE_ACCESS;
